import { render } from "./011-VRParkOrcaBeat.vue?vue&type=template&id=71fed212&scoped=true"
import script from "./011-VRParkOrcaBeat.vue?vue&type=script&lang=js"
export * from "./011-VRParkOrcaBeat.vue?vue&type=script&lang=js"

import "@/assets/css/news.css?vue&type=style&index=0&id=71fed212&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71fed212"]])

export default __exports__